import React, { useEffect, useState } from "react";
import { createdPass } from "../../../../services/OrderService";
import { postPaymentMethodByAdmin, UpdatePass, updateUserDetail, uploadAvatar } from "../../../../services/UserService";
import { ActiveType } from "../../../../models/Login";
import { ImageInputData } from "../../../hooks/useImageUploadInput";
import useAlertDialog from "../../../hooks/useAlertDialog";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";

export default function useUpdatePaymentMethod(props: { setLoading: (val: boolean) => void }) {
	const { openAlertDialog } = useAlertDialog();
	const doUpdate = async (dataIndex: number[]) => {
		props.setLoading(true)
		try {
			await postPaymentMethodByAdmin(dataIndex);
			openAlertDialog?.(AlertType.Success, "Thay đổi vị trí thành công!", () => {
				props.setLoading(false);
			});
		} catch (err: any) {
			console.error(err);
			openAlertDialog?.(AlertType.Fail, err?.response.data?.message || "An error has occurred!", () => {
				props.setLoading(false);
			});
		}
	};

	return {
		doUpdate,
	};
}
